import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { ChevronLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const NoticeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotice = async () => {
      try {
        const res = await api.get(`/requirements/${id}`);
        setNotice(res.data);
      } catch (err) {
        console.error('Error fetching notice:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchNotice();
  }, [id]);

  if (loading) {
    return (
      <div className="p-8 max-w-4xl mx-auto animate-pulse">
        <div className="h-8 bg-gray-200 rounded w-1/4 mb-8"></div>
        <div className="h-64 bg-gray-100 rounded-3xl w-full mb-8"></div>
        <div className="space-y-4">
          <div className="h-4 bg-gray-100 rounded w-full"></div>
          <div className="h-4 bg-gray-100 rounded w-5/6"></div>
          <div className="h-4 bg-gray-100 rounded w-4/6"></div>
        </div>
      </div>
    );
  }

  if (!notice) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-2xl font-bold text-gray-800">Notice not found</h2>
        <button 
          onClick={() => navigate('/')}
          className="mt-4 text-indigo-600 font-semibold hover:underline"
        >
          Back to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <motion.button 
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-400 hover:text-gray-900 transition-colors mb-12 font-bold text-sm uppercase tracking-widest"
      >
        <ChevronLeft size={18} />
        Back
      </motion.button>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-[2.5rem] shadow-2xl shadow-indigo-900/5 border border-gray-50 overflow-hidden p-10 md:p-16"
      >
        <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-8 tracking-tight">
          {notice.title}
        </h1>

        <div className="prose prose-2xl prose-indigo max-w-none">
          <p className="text-3xl md:text-4xl text-gray-500 leading-relaxed whitespace-pre-wrap font-medium">
            {notice.description}
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default NoticeDetails;
